
// On server, log to file
if (typeof window === "undefined") {
    // Do this conditionally to avoid this large package getting into client JS files
    const { createLogger, format, transports } = require('winston');

    const logger = createLogger({
        level: 'info',
        exitOnError: false,
        format: format.json(),
        transports: [
            new transports.File({ filename: `./logs/trailways-website.log` }),
            new transports.Console()
        ],
    });
    module.exports = logger;

} else { // On client, log to datadog

    const logger = {
        log(level, message) {
            if (window.DD_LOGS && window.DD_LOGS.logger) {
                if (level === 'error') {
                    window.DD_LOGS.logger.error(message);
                } else {
                    window.DD_LOGS.logger.info(message);
                }
            }
        }
    }

    module.exports = logger;
}
